<div class="ks-card">
  <header class="ks-card-header">
    <div class="ks-card-header__title">
      <h2 class="ks-h2">Impersonation</h2>
    </div>
    <div class="ks-card-header__tools">
      <button
        type="button"
        ktTooltip="Close"
        class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
        (click)="closeDialog()"
      >
        <span inlineSVG="assets/icons/Close.svg"></span>
      </button>
    </div>
  </header>
  <main class="ks-card-body">
    <p [innerHTML]="'View as Another User'"></p>
    <div class="ks-pt-5">
      <kt-autocomplete
        [label]="'User'"
        [color]="'neutral'"
        [control]="userctrl"
        [optionsType]="'API'"
        [optionType]="'OBJECT'"
        [optionsAPI]="getTeamUsers.bind(this)"
        [objectOptionReq]="{
          idKey: 'id',
          dataPath: 'data',
          labelFormatter: formatUser,
          valueFormatter: formatUser
        }"
      ></kt-autocomplete>
    </div>
  </main>
  <footer class="ks-card-footer">
    <button type="button" class="ks-btn-sm ks-btn-outline-neutral" (click)="closeDialog()">
      Cancel
    </button>
    <button type="button" class="ks-btn-sm ks-btn-primary" (click)="chooseUser()">Confirm</button>
  </footer>
</div>
